import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { BidList as BidListType } from "interfaces";

export class BidList extends ListStoreConstructor<BidListType> {
  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        return services.getBidList(params).then((response) => ({
          content: response.content || [],
          size: response.size || 0,
          totalPages: response.totalPages || 0,
          totalElements: response.totalElements || 0,
        }));
      },
      {
        pollingInterval: 10000,
        defaultSorters: { statusDate: "desc" },
      }
    );
  }
}
